import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

// Wave-1 R1/R2 — when a customer is signed in, attach their session bearer to
// public checkout + analysis calls so the backend can stamp ownership on the
// payment_transactions and analyses documents at write time. This does not
// affect anonymous callers (V1 behavior preserved).
api.interceptors.request.use((cfg) => {
  try {
    const tok = localStorage.getItem("govbidiq_customer_session");
    if (tok && !cfg.headers.Authorization) {
      cfg.headers.Authorization = `Bearer ${tok}`;
    }
  } catch (_) { /* ignore */ }
  return cfg;
});

export const extractDocument = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const res = await axios.post(`${API}/extract`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const createAnalysis = async (payload) => {
  const res = await api.post("/analyses", payload);
  return res.data;
};

export const getAnalysis = async (id) => {
  const res = await api.get(`/analyses/${id}`);
  return res.data;
};

export const getSharedAnalysis = async (token) => {
  const res = await api.get(`/analyses/share/${token}`);
  return res.data;
};

export const listAnalyses = async () => {
  const res = await api.get(`/analyses`);
  return res.data;
};
